import React from 'react';
import PropTypes from 'prop-types';

const DisconnectIcon = ({ fillColor = '#000', ...props }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.19922 1.2002L9.59922 1.2002V2.4002L2.39922 2.4002L2.39922 15.6002H9.59922V16.8002H1.19922L1.19922 1.2002ZM13.0235 4.97593L17.0311 8.98356L13.0401 13.3072L12.1583 12.4932L14.8288 9.60019H4.79922V8.4002L14.7507 8.4002L12.175 5.82446L13.0235 4.97593Z"
        fill={fillColor}
      />
    </svg>
  );
};

DisconnectIcon.propTypes = {
  fillColor: PropTypes.string,
};

export default DisconnectIcon;
